/**
 * Destinatario en el modal de Concepto (cierre diario).
 * Solo si el tipo tiene «Asociar a usuario». No reemplaza el badge F3.
 */

export function cierreDetalleDestinatario(mov: {
  destinatarioNombre?: string | null;
  destinatario_nombre?: string | null;
  asociarUsuario?: boolean | null;
  asociar_usuario?: boolean | null;
}): { show: boolean; nombre: string } {
  const asociar = mov.asociarUsuario ?? mov.asociar_usuario;
  const nombre = String(
    mov.destinatarioNombre ?? mov.destinatario_nombre ?? "",
  ).trim();
  if (asociar === false) {
    return { show: false, nombre: "" };
  }
  if (asociar === true) {
    return { show: true, nombre: nombre || "Sin usuario" };
  }
  if (nombre) {
    return { show: true, nombre };
  }
  return { show: false, nombre: "" };
}
